// App Imports
import { isEmpty } from '../../../setup/helpers'
import {
  SET_USER,
  LOGIN_REQUEST,
  LOGIN_RESPONSE,
  RESET_REQUEST,
  RESET_RESPONSE,
  RESET__PASSWORD_REQUEST,
  RESET__PASSWORD_RESPONSE,
  UPDATE_USER_PROFILE_REQUEST,
  UPDATE_USER_PROFILE_RESPONSE,
  UPDATE_USER_PROFILE_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_RESPONSE,
  UPDATE_USER_FAILURE,
  REFRESH_REQUEST,
  REFRESH_RESPONSE,
  LOGOUT,
  UPDATE_USER,
  REGISTER_NEW_USER_REQUEST,
  REGISTER_NEW_USER_RESPONSE,
  PM_API_KEY_REQUEST,
  PM_API_KEY_SUCCESS,
  PM_API_KEY_FAILURE,
  PM_API_KEY_CLEAR,
  GET_PM_API_KEY_REQUEST,
  GET_PM_API_KEY_SUCCESS,
  GET_PM_API_KEY_FAILURE,
  UPDATE_PM_API_KEY_REQUEST,
  UPDATE_PM_API_KEY_SUCCESS,
  UPDATE_PM_API_KEY_FAILURE,
  updateUserLocalStorage, GET_FEAT_SETTING_REQUEST, GET_FEAT_SETTING_RESPONSE, GET_FEAT_SETTING_FAILURE
} from './actions'

// Initial State
export const userInitialState = {
  error: null,
  isLoading: false,
  isAuthenticated: false,
  details: null,
  apiCreds: null,
  isFeatureEnabled: {
    apiKey: false,
  },
}

// State
export default (state = userInitialState, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty(action.user),
        details: action.user,
        error: action.error
      }

    case UPDATE_USER:
      const newUser = Object.assign({}, state.details, action.newData);
      updateUserLocalStorage(newUser);
      return {
        ...state,
        isAuthenticated: !isEmpty(state.details),
        details: newUser,
      }

    case LOGIN_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading
      }

    case LOGIN_RESPONSE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      }

    case UPDATE_USER_PROFILE_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading
      }

    case UPDATE_USER_PROFILE_RESPONSE:
      // check local storage for refreshed user obj:
      var userDetails = JSON.parse(window.localStorage.getItem('user'));
      return {
        ...state,
        error: action.error,
        details: userDetails,
        isLoading: false,
      }
    case UPDATE_USER_PROFILE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }

    case RESET_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading
      }

    case RESET_RESPONSE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      }

    case REFRESH_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading
      }

    case REFRESH_RESPONSE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      }

    case LOGOUT:
      return {
        ...state,
        error: null,
        isLoading: false,
        isAuthenticated: false,
        details: null
      }

    case REGISTER_NEW_USER_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading
      }

    case REGISTER_NEW_USER_RESPONSE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }

    case PM_API_KEY_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading || true
      }

    case PM_API_KEY_SUCCESS:
      return {
        ...state,
        apiCreds: action.apiCreds,
        isLoading: false,
        error: null,
      };

    case PM_API_KEY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }

    case PM_API_KEY_CLEAR:
      return {
        ...state,
        apiCreds: null
      };

    case GET_PM_API_KEY_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading || true
      }

    case GET_PM_API_KEY_SUCCESS:
      return {
        ...state,
        apiCreds: action.apiCreds,
        isLoading: false,
        error: null,
      };

    case GET_PM_API_KEY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }

    case UPDATE_PM_API_KEY_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading || true
      }

    case UPDATE_PM_API_KEY_SUCCESS:
      return {
        ...state,
        apiCreds: action.apiCreds,
        isLoading: false,
        error: null,
      };

    case UPDATE_PM_API_KEY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_FEAT_SETTING_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading || true
      }

    case GET_FEAT_SETTING_RESPONSE:
      return {
        ...state,
        isFeatureEnabled: action.isFeatureEnabled,
        isLoading: false,
        error: null,
      };

    case GET_FEAT_SETTING_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }

    default:
      return state
  }
}